import React, { Fragment, useEffect } from "react";
import Swiper from "../../../modules/env/swiper-bundle.min";
import { PickAmPmSlide } from "./PickAmPmSlide";
import { PickDaySlide } from "./PickDaySlide";
import { PickHourSlide } from "./PickHourSlide";
import { PickMinSlide } from "./PickMinSlide";
import { PickMonthSlide } from "./PickMonthSlide";
import { PickWeek } from "./PickWeek";
import { PickYearSlide } from "./PickYearSlide";


export const ExeCycleLayer = (props) => {
    const {mode} = props;

    // PickerTime
    let pickslideDayWhen;
	let pickslideDayHour;
	let pickslideDayMinute;

    let dayWhenInNum;
	let dayHourInvalue;
	let dayMinuteInvalue;

	let weekInvalue = "";
	let wkword = "";

    // PickerDate
    let pickslideTodayYear;
	let pickslideTodayMonth;
	let pickslideTodayDay;

    var todayYearInNum;
	var todayMonthInvalue;
	var todayDayInvalue;

	var weekInvaluetday = "";
	var wkwordtday = "";

    const pickerStartFn_exe = () => {
        //언제
		pickslideDayWhen = new Swiper('.pickslide-day-when', {
            // Optional parameters
            direction: 'vertical',
            //loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                init: function(){
                    dayWhenInNum = $(".pickslide-day-when .swiper-slide-active span").html();
                },
                slideChangeTransitionEnd: function(){
                    dayWhenInNum = $(".pickslide-day-when .swiper-slide-active span").html();
                },
            },
        });

        //시
        pickslideDayHour = new Swiper('.pickslide-day-hour', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    dayHourInvalue = $(".pickslide-day-hour .swiper-slide-active span").html();
                },
            },
        });

        //분
        pickslideDayMinute = new Swiper('.pickslide-day-minute', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    dayMinuteInvalue = $(".pickslide-day-minute .swiper-slide-active span").html();
                },
            },
        });
    }

    const pickerEndFn_exe = () => {
        pickslideDayWhen.destroy();
		pickslideDayHour.destroy();
		pickslideDayMinute.destroy();
    }

    const pickerStartFn_todayexe = () => {
        //년도
		pickslideTodayYear = new Swiper('.pickslide-today-year', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    todayYearInNum = $(".pickslide-today-year .swiper-slide-active span").html();
                },
            },
        });

        //월
        pickslideTodayMonth = new Swiper('.pickslide-today-month', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    todayMonthInvalue = $(".pickslide-today-month .swiper-slide-active span").html();
                },
            },
        });

        //일
        pickslideTodayDay = new Swiper('.pickslide-today-day', {
            // Optional parameters
            direction: 'vertical',
            loop: true,
            slidesPerView: 5,
            centeredSlides: true,
            on:{
                slideChangeTransitionEnd: function(){
                    todayDayInvalue = $(".pickslide-today-day .swiper-slide-active span").html();
                },
            },
        });
    }

    const pickerEndFn_todayexe = () => {
        pickslideTodayYear.destroy();
		pickslideTodayMonth.destroy();
		pickslideTodayDay.destroy();
    }

    useEffect(()=>{
        if(mode === "TIME") {
            $(".open-exercise-cycle").click(function(){	
                $(".blgrn-box.intwobox > div").hide();
                $(".blgrn-box.intwobox > .exe-cycle").show();
                pickerStartFn_exe();
            });
    
            $(".traning-target-set .exe-cycle .tbns-area a").click(function(){
                //확인버튼일 경우 저장 세팅
                if($(this).hasClass("wht")){
        
                    let weekChecked = $(".pick-week-area.target ul li").find("a.on");
                    let weekLength = weekChecked.length; 
                    $(".pick-week-area.target ul li").each(function(){  //요일선택
                        if($(this).find("a").hasClass("on")){
                            wkword = $(this).find("a.on").html() + ", ";
                            weekInvalue += wkword;
                        }
                    });
        
                    var totalValueDay = weekInvalue+" "+ dayWhenInNum+", "+dayHourInvalue+":"+dayMinuteInvalue;
                    //console.log(totalValueDay); //결과 저장값
                    $(".excyc-result").val(totalValueDay);
                }
        
                weekInvalue = "";
        
                pickerEndFn_exe();
                $(".blgrn-box.intwobox > div").hide();
                $(".blgrn-box.intwobox > .first").show();
            });
        } else {
            //열기
            $(".open-today-dateset").click(function(){	
                $(".intwobox.tday > div").hide();
                $(".intwobox.tday .exe-cycle").show();
                pickerStartFn_todayexe();

            });
            //닫기
            $(".traning-today-set .exe-cycle .tbns-area a").click(function(){
                //확인버튼일 경우 저장 세팅
                if($(this).hasClass("wht")){

                    var weekChecked = $(".pick-week-area.today ul li").find("a.on");
                    var weekLength = weekChecked.length; 
                    $(".pick-week-area.today ul li").each(function(){  //요일선택
                        if($(this).find("a").hasClass("on")){
                            wkwordtday = $(this).find("a.on").html();
                            weekInvaluetday += wkwordtday;
                        }
                    });

                    var totalValuetoDay = todayYearInNum+"-"+todayMonthInvalue+"-"+todayDayInvalue+"("+weekInvaluetday+")";
                    $(".td-date-result").val(totalValuetoDay);//결과 저장값
                }

                weekInvaluetday = "";

                pickerEndFn_todayexe();
                $(".intwobox.tday > div").hide();
                $(".intwobox.tday .first").show();

            });
        }
        
    }, []);

    return (
        <div className="exe-cycle">
            <div className="blgr-title">운동 주기 설정</div>

            <PickWeek mode={mode}/>

            <div className="picker-container repad w3">

                {mode === "TIME"
                    ? <TimeSlide />
                    : <DateSlide />
                } 
            </div>

            <div className="tbns-area">
                <a className="btn-round gray">취소</a>
                <a className="btn-round wht">확인</a>
            </div>
        </div>
    );
};

export const TimeSlide = () => {
    return(
        <Fragment>
            <PickAmPmSlide />
            <PickHourSlide />
            <PickMinSlide />
            <i className="dots d2"></i>
        </Fragment>
    );
}

export const DateSlide = () => {
    return(
        <Fragment>
            <PickYearSlide />
            <PickMonthSlide />
            <PickDaySlide />
        </Fragment>
    );
}